import { Link, Stack, Text } from "basis";
import { SvgInline } from "components/SvgInline/SvgInline";
import { EnhancedAccount } from "library/accounts/types";
import { AccountHeader } from "../components/AccountHeader";

type Props = {
  email: string;
  account: EnhancedAccount;
};

export const UpdateEmailSuccess = ({ email, account }: Props) => (
  <Stack gap="8">
    <AccountHeader account={account} />
    <SvgInline name="icon-celebrate" size="120" />
    <Text as="h3" textStyle="heading5" color="primary.blue.t100">
      Your email address has been updated successfully.
    </Text>
    <Text>{email}</Text>
    <Link
      appearance="primary-button"
      width="256"
      href="/manage-personal-details"
      newTab={false}
    >
      Manage personal details
    </Link>
  </Stack>
);
